import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import {ListWrapper} from './list/List'

const authorsBreadcrumbs: Array<PageLink> = [
  {
    title: 'Gerenciamento de Vídeos',
    path: '/apps/videos-management/videos',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const Page = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='videos'
          element={
            <>
              <PageTitle breadcrumbs={authorsBreadcrumbs}>Lista de Vídeos</PageTitle>
              <ListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/videos-management/videos' />} />
    </Routes>
  )
}

export default Page
